var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshCw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.0680234 14.6384L0.0730234 14.6254C0.221023 14.2584 0.581023 14.0004 1.00002 14.0004H7.00002C7.55202 14.0004 8.00002 14.4484 8.00002 15.0004C8.00002 15.5524 7.55202 16.0004 7.00002 16.0004H3.52502L6.32502 18.6314C8.28902 20.5964 11.092 21.4064 13.771 20.8004C16.45 20.1944 18.631 18.2564 19.547 15.6664C19.731 15.1454 20.303 14.8734 20.823 15.0574C21.343 15.2414 21.616 15.8134 21.432 16.3334C20.287 19.5704 17.561 21.9934 14.212 22.7504C10.863 23.5074 7.36002 22.4944 4.93202 20.0664L1.99902 17.3114V20.9994C1.99902 21.5514 1.55102 21.9994 0.999023 21.9994C0.447023 21.9994 -0.000976562 21.5514 -0.000976562 20.9994V15.0014C-0.000976562 14.8774 0.0210234 14.7544 0.0670234 14.6374L0.0680234 14.6384ZM22.932 9.36036L22.927 9.37336C22.779 9.74036 22.419 9.99836 22 9.99836H16C15.448 9.99836 15 9.55036 15 8.99836C15 8.44636 15.448 7.99836 16 7.99836H19.475L16.675 5.36736C14.711 3.40236 11.908 2.59236 9.22902 3.19836C6.55002 3.80436 4.36902 5.74236 3.45302 8.33236C3.26902 8.85336 2.69702 9.12536 2.17702 8.94136C1.65702 8.75736 1.38402 8.18536 1.56802 7.66536C2.71302 4.42836 5.43902 2.00536 8.78802 1.24836C12.137 0.491359 15.64 1.50436 18.068 3.93236L21.001 6.68736V2.99936C21.001 2.44736 21.449 1.99936 22.001 1.99936C22.553 1.99936 23.001 2.44736 23.001 2.99936V8.99736C23.001 9.12136 22.979 9.24436 22.933 9.36136L22.932 9.36036Z",
    fill: "#2C3439"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCw);
export default __webpack_public_path__ + "static/media/refresh-cw.cb4e6d62259b0009a657bba5dbda7ce9.svg";
export { ForwardRef as ReactComponent };